import { t } from '@/i18n';
import { z } from 'zod';
import { businessForm } from './project';

/// ////////////////////////////////////////////
/// enum
/// ////////////////////////////////////////////

export const fundBusinessForm = businessForm.extract([
  'subsidy',
  'investment',
  'debt-guarantee',
  'loan',
  'others',
]);

export const FundBusinessFormTitleModifier = {
  subsidy: t('fund-business-subsidy-title'),
  investment: t('fund-business-investment-title'),
  'debt-guarantee': t('fund-business-debt-guarantee-title'),
  loan: t('fund-business-loan-title'),
  others: t('fund-business-others-title'),
} as const satisfies Record<z.infer<typeof fundBusinessForm>, string>;

export const fundBusinessForInvestmentPerformanceType = z.enum([
  'decision',
  'execution',
]);

export const FundBusinessForInvestmentPerformanceTitleModifier = {
  decision: t('decision'),
  execution: t('fund-business-execution'),
} as const satisfies Record<
  z.infer<typeof fundBusinessForInvestmentPerformanceType>,
  string
>;

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

const FundBusinessCellModel = z.object({
  count: z.number().int().nonnegative().nullable(),
  amount: z.number().nullable(),
});

const FundBusinessYearCellModel = z.object({
  amountInfo: FundBusinessCellModel.nullish(),
});

const FundBusinessYearCellsModel = FundBusinessYearCellModel.array();

export const FundBusinessRowModel = z.object({
  id: z.string(),
  title: z.string().nullable(),
  decidedAmountInfo: FundBusinessCellModel.nullish(),
  estimatedAmountInfo: FundBusinessCellModel.nullish(),
  yearAmountInfos: FundBusinessYearCellsModel,
});

const FundBusinessBaseModel = z.object({
  businessForm,
  title: z.string().nullable(),
  performances: FundBusinessRowModel.array(),
  priorId: z.string().nullish(),
});

export const FundBusinessModel = FundBusinessBaseModel.extend({
  id: z.string().uuid(),
});

export const FundBusinessesModel = FundBusinessModel.array();

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const FundBusinessUpdateFormSchema = FundBusinessBaseModel;

export const FundBusinessUpsertMutationParamsSchema =
  FundBusinessBaseModel.extend({
    title: z.string().nullish(),
  });

export const FundBusinessForInvestmentUpsertFormSchema =
  FundBusinessBaseModel.pick({
    businessForm: true,
    performances: true,
  }).extend({
    title: z.string().nullish(),
  });

export const FundBusinessCreateFormSchema = z.object({
  title: z.string().nullish(),
  businessForm: fundBusinessForm,
});
